import { FC } from 'react';
import { SvgProps } from '../interfaces/Icon';

const Apple: FC<SvgProps> = ({ size, className, color }) => {
  return (
    <svg
      width={size ? size : '56'}
      height="8"
      viewBox={`0 0 ${size ? size : '56'} 8`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-full"
    >
      <rect
        x="0.5"
        y="0.5"
        width={size ? Number(size) - 1 : '55'}
        height="7"
        rx="3.5"
        fill="#369BFF"
        fillOpacity="0.5"
        stroke="#369BFF"
      />
    </svg>
  );
};

export default Apple;
